import { GenericDatabase } from './GenericDatabase'

const DB_NAME = 'TechnicalDocumentation'
const DB_VERSION = 1
const STORE_STRUCTURES = 'spmStructures'
const STORE_FILES = 'pdfFiles'

const dbInstance = new GenericDatabase(DB_NAME, DB_VERSION, [
    { name: STORE_STRUCTURES, keyPath: 'spm' },
    { name: STORE_FILES, keyPath: 'blobPath' }
])

const initDbDocumentation = () => {
    return dbInstance.init()
}

const saveSpmStructure = (spmStructure, database) => {
    if (spmStructure && typeof spmStructure.spm === 'string') {
        spmStructure.spm = spmStructure.spm.toUpperCase().trim()
    }
    return dbInstance.put(STORE_STRUCTURES, spmStructure, database)
}

const getSpmStructure = (spmCode, database) => {
    const normalizedKey = typeof spmCode === 'string' ? spmCode.toUpperCase().trim() : spmCode
    return dbInstance.get(STORE_STRUCTURES, normalizedKey, database)
}

const getAllSpmStructures = (database) => {
    return dbInstance.getAll(STORE_STRUCTURES, database)
}

const savePdfFile = (pdfFileData, database) => {
    return dbInstance.put(STORE_FILES, pdfFileData, database)
}

const getPdfFile = (blobPath, database) => {
    return dbInstance.get(STORE_FILES, blobPath, database)
}

const deleteSpmDocumentation = async (spmCode, database) => {
    const normalizedKey = typeof spmCode === 'string' ? spmCode.toUpperCase().trim() : spmCode
    const struct = await getSpmStructure(normalizedKey, database)
    if (struct && struct.steps) {
        for (const step of struct.steps) {
            if (step.files) {
                for (const file of step.files) {
                    await dbInstance.delete(STORE_FILES, file.blobPath, database)
                }
            }
        }
    }
    return dbInstance.delete(STORE_STRUCTURES, normalizedKey, database)
}

export default {
    initDbDocumentation,
    saveSpmStructure,
    getSpmStructure,
    getAllSpmStructures,
    savePdfFile,
    getPdfFile,
    deleteSpmDocumentation
}
